import React from 'react';
import './ABComponent.css';

const ABComponent = () => {
    return (
        <div className="about-container">
            <p className="sec-pera">Callistus is a multinational brand which is supported by entrepreneurs with vast experience in various countries for more than 25 years in the Window Covering Industry. Callistus Window Fashions has carved a niche by combining innovation, research, quality, technology and experience giving birth to the largest range of Blinds in the world which are corresponded with the highest options of excellent Operating Systems and huge array of complementing fabrics.</p>
            <section className="about-section">
                <div className="about-row">
                    <div className="about-text">
                        <h2>Why Callistus</h2>
                        <p>
                            Being the most Innovative, Quality Oriented and determined to give unparalleled service is our Motto. The genesis of our Blinds with inceptive research and innovative ideas from a customer-centric solution-based outlook and strong establishment of brand values makes us stand out as leaders. We have the world's largest range of 16 types of Blinds, Multiple Operating Systems and 2000+ shades of fabrics to match and create the best interiors for your home and office. We believe that innovation in Window Blinds brings a new dimension and comfort in the living space which multiplies the ease to light control according to need, mood, and privacy providing Luxury.
                        </p>
                    </div>
                    <div className="about-image">
                        <img src="/Assets/AboutPage_Images/A1.webp" alt="About Callistus" />
                    </div>
                </div>

                <div className="overlay-section">
                    <div className="overlay-content">
                        <h2>Our Unique Culture</h2>
                        <p>
                            'Growth is Life' - We strive to create a culture that reinforces our values for everyone associated with us. Improve the quality of life of the society and community at large, wherein major focus is on value creation based on leadership with trust. We are focused on enhancing the satisfaction of team members and communities we serve securing this legacy of taking initiative. Progressing towards the sustainability, we look for solutions to every problem; Embrace change and pursue development and reducing friction in every area of the company.
                        </p>
                    </div>
                </div>

                <div className="half-overlay-section">
                    <div className="half-overlay-content">
                        <h2>Innovative Window Styling</h2>
                        <p>
                            For the past 25 years we’ve made it our passion to understand the many elements of light. From making a cloudy day seem brighter or helping a hot room feel cooler and more comfortable, we seek to understand your place and its relationship to daylight. That is what makes us different – our attention to detail with every product that we present. That is what makes our window coverings an everyday luxury. That is what makes our products more than just covering your windows.
                        </p>
                    </div>
                </div>

                {/* ✅ New 4 Column Section */}
                <div className="four-column-section">
                    <div className="column-item">
                        <h2>Vision</h2>
                        <p>
                            We significantly aim to become one of the top five leading multinational organizations in Window covering industry by leveraging our expertise worldwide.
                        </p>
                    </div>
                    <div className="column-item">
                        <img src="/Assets/AboutPage_Images/A2.webp" alt="Design 1" />
                    </div>
                    <div className="column-item">
                        <h2>Mission</h2>
                        <p>
                            Improve the quality of life of the society and community at large wherein major focus is on value creation based on Leadership with Trust.
                        </p>
                    </div>
                    <div className="column-item">
                        <img src="/Assets/AboutPage_Images/A3.webp" alt="Design 2" />
                    </div>
                </div>

                <div className="overlay-section overlay-section2">
                    <div className="overlay-content">
                        <h2>Our Values</h2>
                        <p>
                            <li>Our Commitment :</li>
                            <span>We deal with Commitment and Integrity being honest, reasonable and transparent to everyone associated with us.</span>
                            <li>Customer Service Focus :</li>
                            <span>We ensure the desired level of quality for our Customers with continued availability of Product with right quality at right time.</span>
                            <li>Excellence & Quality :</li>
                            <span>We focus on innovation, outstanding service, and operational excellence for our clients providing the best customer service in the industry.</span>
                            <li>Pioneering Innovation :</li>
                            <span>We will be strong and agile, courageously taking on challenges, using in depth customer insight to develop innovative solutions.</span>
                            <li>Ownership and Responsibility :</li>
                            <span>We strive to continuously rejuvenate every living and working space of people and bring joy to their lives.</span>
                            <li>People :</li>
                            <span>We strongly believe in individual ability and creating an environment in which the entrepreneurial spirit is encouraged within the team</span>
                        </p>
                    </div>
                </div>

            </section>
        </div>
    );
};

export default ABComponent;
